import {Component} from "@angular/core";

import { LoadingService } from "src/app/services/loading.service";

@Component({
    selector: "app-full-loading-indicator",
    templateUrl: "./full-loading-indicator.component.html",
    styleUrls: ["./full-loading-indicator.component.scss"]
})
export class FullLoadingIndicatorComponent {
    constructor(public loadingService: LoadingService) {}
}
